import React from "react";
import RenderLanding from "./RenderLanding";
import RenderComponent from "./RenderComponent";
import RenderIframe from "./RenderIframe";
import { useApplicationContext } from "../context/ApplicationContext";
import {
  isLandingView,
  isIframeView,
  isComponentView,
} from "../utils/landingSelection";

/**
 * ContentArea - Main content routing component
 * 
 * Routes between RenderLanding, RenderIframe, and RenderComponent
 * based on the current activeView state.
 * Uses useApplicationContext to access state from context provider.
 */
export const ContentArea: React.FC = () => {
  // Destructure only the state properties we need
  const {
    activeView,
  } = useApplicationContext();
  
  if (isLandingView(activeView)) {
    return (
      <div className="app-content">
        <RenderLanding />
      </div>
    );
  } else if (isIframeView(activeView)) {
    return (
      <div className="app-content">
        <RenderIframe key={activeView.url} />
      </div>
    );
  } else if (isComponentView(activeView)) {
    return (
      <div className="app-content">
        <RenderComponent />
      </div>
    );
  }

  return null;
};
